import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ForumService } from '../forum.service';
import { UiService } from '../../../core/services/core.ui.service';
import * as _ from 'lodash';

@Component({
    selector: 'forum-edit-modal',
    template: require('./forum.edit-modal.component.html')
})
export class ForumEditModalComponent implements OnInit {

    @Input() forum: any;
    @Input() project: any;
    @Input() domain: string;
    
    @Output() onClose: EventEmitter<any> = new EventEmitter();
    @Output() onUpdate: EventEmitter<any> = new EventEmitter();

    ModerationChoices = { 'Yes': 2, 'No': 0 };
    PublicChoices = { 'Yes': 'Y', 'No': 'N' };
    sendAllPostsTo: any;
    title: string;
    emailError: boolean;
    forumNameError: boolean;
    saving: boolean;

    constructor(
        private forumService: ForumService,
        private uiService: UiService
    ) { }

    ngOnInit() {
        this.sendAllPostsTo = this.getSendAllPostsToList(this.forum);
        this.title = this.forum.id ? 'Add discussion' : 'Edit discussion';
    }

    setConfigValue(path, value) {
        if (value == undefined || value == _.get(this, path)) return false;
        _.set(this, path, value);
    }

    post() {
        this.emailError = !this.validateSendAllPosts(this.sendAllPostsTo);
        this.forumNameError = _.isEmpty(this.forum.forumName);

        if (this.emailError || this.forumNameError) {
            return false;
        }

        this.forum.sendAllPostsTo = _.map(this.sendAllPostsTo, 'text').join(',');
        this.saveForum(this.forum);
    }

    validateSendAllPosts(list) {
        const isNotEmail = (item) => {
            return !item.text.match('\\w+@\\w+\\.\\w+');
        }
        const badEmails = _.filter(list, isNotEmail);
        return (badEmails.length == 0);
    }

    getSendAllPostsToList(forum) {
        return _.filter(
            (forum?.sendAllPostsTo || '').split(','),
            _.size
        ).map((email) => {
            return { text: email };
        });
    }

    saveForum(forum) {
        const data = _.defaults(
            forum,
            { section: 'project', refId: this.project.id }
        );

        this.saving = true;

        return this.forumService.postForum(forum.id, data)
        .then((response) => {
            if (forum.id === 0) {
                this.uiService.message.showSuccess('Discussion created');
            } else {
                this.uiService.message.showSuccess('Discussion updated');
            }
            this.saving = false;
            this.onUpdate.emit();
        }, (response) => {
            if (forum.id === 0) {
                this.uiService.message.showError('An error occurred while creating the discussion: ' + response.statusText);
            } else {
                this.uiService.message.showError('An error occurred while saving the discussion: ' + response.statusText);
            }
            this.saving = false;
            this.onClose.emit();
        });
    }
}